//#region src/core/ui/slider/vars.ts
/**
* CSS custom property names for slider visual state.
*
* @internal
*/
const SliderCSSVars = {
	/** Fill level percentage (0–100). */
	fill: "--media-slider-fill",
	/** Pointer position percentage (0–100). */
	pointer: "--media-slider-pointer",
	/** Buffer level percentage (0–100). */
	buffer: "--media-slider-buffer"
};
//#endregion
export { SliderCSSVars };
